import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { RiDeleteBin6Fill } from 'react-icons/ri';
import { LiaShoppingBagSolid } from 'react-icons/lia';
import ProductServices from '../services/API/ProductServices';
import CartServices from '../services/API/CartService';
import { BASE_URL } from '../services/Constant';
import Sidebar from './Sidebar';

const Main = () => {
  const [count, setCount] = useState(1);
  const { pathname } = window.location;
  const id = pathname.split("/").pop();
  const [products, setProducts] = useState([]);
  const [cartProducts, setCartProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      getCartData(userId); // Fetch cart data when opening the sidebar
    }
  };

  const generateUserId = () => {
    const randomUserId = Math.floor(Math.random() * 1000000);
    sessionStorage.setItem("randomUserId", randomUserId);
    return randomUserId;
  };

  const userId = sessionStorage.getItem("userId") || sessionStorage.getItem("randomUserId") || generateUserId();
  const isLoggedIn = sessionStorage.getItem("userId") !== null;

  const getProductData = async (id) => {
    try {
      const res = await ProductServices.getProductById(id);
      if (res.status) {
        setProducts(res.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching product data:", error);
    }
  };

  const getCartData = async (userId) => {
    try {
      const res = await CartServices.getCart(userId);
      if (res.status) {
        setCartProducts(res.data.order);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching cart data:", error);
    }
  };

  useEffect(() => {
    getProductData(id);
    getCartData(userId);
  }, []);

  const incrementCount = () => {
    setCount(count + 1);
  };

  const decrementCount = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  const handleAddToCart = async () => {
    const cartData = {
      product_id: products.id,
      quantity: count,
      user_id: userId
    };

    try {
      const response = await CartServices.addToCart(cartData);
      if (response.status) {
        console.log("Product added to cart successfully");
        getCartData(userId); // Fetch updated cart data
        toggleSidebar(); // Open the sidebar on successful addition
      } else {
        console.error("Failed to add product to cart");
      }
    } catch (error) {
      console.error("Error adding product to cart:", error);
    }
  };

  const updateQuantity = async (productId, newQuantity) => {
    const payload = {
      cart_id: productId,
      quantity: newQuantity,
      user_id: userId,
    };
  
    try {
      const response = await CartServices.updateCart(payload);
      if (response.status) {
        console.log("Cart updated successfully");
        getCartData(userId); // Refresh the cart after update
      } else {
        console.error("Failed to update cart");
      }
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  };
  
  const increment = (productId, currentQuantity) => {
    const newQuantity = currentQuantity + 1;
    updateQuantity(productId, newQuantity);
  };
  
  const decrement = (productId, currentQuantity) => {
    if (currentQuantity > 1) {
      const newQuantity = currentQuantity - 1;
      updateQuantity(productId, newQuantity);
    }
  };

  const handleDeleteCartById = async (cartId) => {
    const payload = {
        user_id: userId,
        cart_id: cartId,
      };
    try {
        const response = await CartServices.deleteCartById(payload);
        console.log("Product removed from cart successfully:", response.data);
        getCartData(userId); // Fetch updated cart data
    } catch (error) {
        console.error("Error removing product from cart:", error);
    }
};


  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-16 bg-[#fff]">
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-[#F4CF38]"></div>
    </div>
    );
  }
  const decodeHtml = (html) => {
    let textArea = document.createElement("textarea");
    textArea.innerHTML = html;
    return textArea.value;
  };
  return (
    <>
       <div className="container mx-auto px-4 py-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        {/* Product Image */}
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
          <img src={`${BASE_URL}${products.image}`} alt="product" className="w-full rounded-lg" />
        </div>
        
        {/* Product Details */}
        <div className="space-y-4 text-left">
          <h3 className="text-2xl font-bold text-gray-900">{products.name}</h3>
          <h4 className="text-lg text-gray-600">{products.product_code}</h4>
          <p
  className="text-gray-700"
  dangerouslySetInnerHTML={{ __html: decodeHtml(decodeHtml(products.description)) }}
></p>
          <div className="flex justify-between items-center">
            <div>
              <span className="text-gray-700 font-semibold">Quantity</span>
              <div className="flex items-center space-x-2 border rounded-lg p-2 bg-gray-50">
                <button className="px-3 py-1 bg-[#F4CF38] rounded-lg" onClick={decrementCount}>-</button>
                <span className="text-lg font-semibold">{count.toString().padStart(2, '0')}</span>
                <button className="px-3 py-1 bg-[#F4CF38] rounded-lg" onClick={incrementCount}>+</button>
              </div>
            </div>
            <div>
              <span className="text-2xl font-bold text-black">${products.price}</span>
            </div>
          </div>
          
          {/* Action Buttons */}
          <div className="flex space-x-4 mt-4">
            <button
              className="px-6 py-2 bg-[#F4CF38] text-black font-bold rounded-lg transition"
              onClick={handleAddToCart}
            >
              Add to Cart
            </button>
            <Link to={`/buynow-category?productid=${products.id}&&quantity=${count.toString().padStart(2, '0')}`}>
            <button
              className="px-6 py-2 bg-[#e7e7e7] text-black rounded-lg font-bold transition"
            >
              Buy Now
            </button>
            </Link>
          </div>
        </div>
      </div>
    </div>

        <Sidebar handleDeleteCartById={handleDeleteCartById} isOpen={isOpen} toggleSidebar={toggleSidebar} cartProducts={cartProducts} increment={increment} decrement={decrement} count={count} />

      {/* </div> */}
      {/* <div className={`sidebar-overlay ${isOpen ? 'active' : ''}`} onClick={toggleSidebar}></div> */}
    </>
  );
};

export default Main;
